import PropTypes from 'prop-types';
import React from 'react';

import CosignerSelector from '../CosignerSelector';
import OfferDetailsSection from '../OfferDetailsSection';

const CosignerDetails = ({
  hasCosigner,
  explanationOpen,
  cosignerSelection,
  onCosignerSelectionChange,
  disabled,
}) => {
  const explanationText = <>Do you plan to take the loan with a co-signer?</>;

  return (
    <OfferDetailsSection
      className="cosigner"
      explanationOpen={null}
      title="Co-signer"
      explanationText={explanationText}
      hasExpanded={false}
    >
      <CosignerSelector
        hasCosigner={hasCosigner}
        selected={cosignerSelection}
        onSelectAlone={() => onCosignerSelectionChange('alone')}
        onSelectCosigner={() => onCosignerSelectionChange('cosigner')}
        disabled={disabled}
      />
    </OfferDetailsSection>
  );
};

CosignerDetails.propTypes = {
  hasCosigner: PropTypes.bool.isRequired,
  explanationOpen: PropTypes.bool.isRequired,
  cosignerSelection: PropTypes.string.isRequired,
  onCosignerSelectionChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default CosignerDetails;
